function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    //this.input.addEventListener('change', this.updateQtyMax);
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  /** Setting Quantity input to maximum product quantity on keyboard input **/
  // updateQtyMax() {
  //   let qtyMax = this.input.getAttribute("max");

  //   if (qtyMax != null && Number(this.input.value) > qtyMax) {
  //     this.input.value = (qtyMax != 0) ? qtyMax : 1;
  //   }
  // }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.isBodyClickListenerAdded = false;
    this.boundOnBodyClick = this.onBodyClick.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onBodyClick(event) {
    const clickedElement = event.target;

    if (clickedElement.classList.contains("opacity--filter")) {
      const summaryElement = document.querySelector(
        'summary[aria-controls="menu-drawer"]',
      );

      if (summaryElement) {
        summaryElement.click();
      }
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (!this.isBodyClickListenerAdded) {
      document.body.addEventListener("click", this.boundOnBodyClick);
      this.isBodyClickListenerAdded = true;
    } else if (this.isBodyClickListenerAdded) {
      document.body.removeEventListener("click", this.boundOnBodyClick);
      this.isBodyClickListenerAdded = false;
    }

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        //Opens up second level mobile menu
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");

        //Close out whole mobile menu drawer
        let body = document.querySelector("body");
        body.classList.remove("opacity--filter");

        let headerSearch = document.querySelector(
          ".header__search-container-mobile",
        );
        if (headerSearch) {
          headerSearch.classList.remove("opacity--filter");
        }
      });
      document.body.classList.remove(`opacity--filter`);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer(event);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    //Close out Level 2 menu
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );

    setTimeout(() => {
      //Open up whole menu drawer
      this.mainDetailsToggle.classList.add("menu-opening");

      //<body> BG opacity
      let body = document.querySelector("body");
      body.classList.add("opacity--filter");

      let headerSearch = document.querySelector(
        ".header__search-container-mobile",
      );
      if (headerSearch) {
        headerSearch.classList.add("opacity--filter");
      }
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    document.body.dispatchEvent(new CustomEvent("modalOpened"));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (this.classList.contains("autoplay")) {
      if (this.classList.contains("youtube")) {
        document.querySelector(".js-youtube").src += "&autoplay=1";
      } else {
        document.querySelector(".js-vimeo").src += "?autoplay=1";
      }
    }
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButtons = this.querySelectorAll('button[name="previous"]');
    this.nextButtons = this.querySelectorAll('button[name="next"]');

    if (!this.slider || !this.nextButtons.length) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButtons.forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
    this.nextButtons.forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    //Line below - this apparently needs to be .ceil instead of .round
    //.round was calculating incorrect numbers at higher slide counts
    this.currentPage =
      Math.ceil(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButtons.forEach((button) =>
        button.setAttribute("disabled", "disabled"),
      );
    } else {
      this.prevButtons.forEach((button) => button.removeAttribute("disabled"));
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButtons.forEach((button) =>
        button.setAttribute("disabled", "disabled"),
      );
    } else {
      this.nextButtons.forEach((button) => button.removeAttribute("disabled"));
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButtons.forEach((button) => button.removeAttribute("disabled"));

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.additionalVariantData = JSON.parse(
      document.getElementById("additionalVariantData").textContent,
    );
    this.setColorVariantLabel();
    this.setPriceLabelAddButton();
    this.updateVariantMedia();
    this.addOutOfStockClass();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.setColorVariantLabel();
    this.removeColorVariantLabel();
    this.addOutOfStockClass();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateMaxVariantQuantity();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    let swatches = this.querySelectorAll("input");

    if (swatches.length == 0) {
      this.options = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value,
      );
    } else {
      this.inputs = Array.from(swatches).find((radio) => radio.checked).value;
      this.index = Number(
        document.querySelector("fieldset").getAttribute("node-index"),
      );
      this.options = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value,
      );
      this.options.splice(this.index, 0, this.inputs);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  addOutOfStockClass() {
    const variants = this.getVariantData();

    if (!this.currentVariant) {
      for (let variant of variants) {
        if (variant.available) {
          this.currentVariant = variant;
          break;
        }
      }
    }

    variants.forEach((variant) => {
      if (variant.option1 === this.currentVariant.option1) {
        if (!variant.available) {
          if (variant.option2) {
            let variantOption = document.querySelector(
              `input[value="${variant.option2}"]`,
            );
            variantOption.nextElementSibling.classList.add("strike-thru");
          }

          if (variant.option3) {
            let variantOption = document.querySelector(
              `input[value="${variant.option3}"]`,
            );
            variantOption.nextElementSibling.classList.add("strike-thru");
          }
        } else {
          if (variant.option2) {
            let variantOption = document.querySelector(
              `input[value="${variant.option2}"]`,
            );
            variantOption.nextElementSibling.classList.remove("strike-thru");
          }

          if (variant.option3) {
            let variantOption = document.querySelector(
              `input[value="${variant.option3}"]`,
            );
            variantOption.nextElementSibling.classList.remove("strike-thru");
          }
        }
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true,
    );
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateVariantMedia() {
    let color_inputs = document.querySelectorAll("input[name=Color]");
    let color_dropdown = document.querySelectorAll(
      "select[name='options[Color]']",
    );
    let thumbs = document.querySelectorAll(".thumbnail-list__item img");
    let stackedThumbs = document.querySelectorAll(".product__media-item  img");

    if (color_inputs.length > 0) {
      color_inputs.forEach((i) => {
        //Check if swatch input or dropdown
        if (i.checked) {
          if (thumbs.length > 0) {
            thumbs.forEach((t) => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              // console.log(searchValue)
              if (t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none";
              }
            });
          }

          if (stackedThumbs.length > 0) {
            stackedThumbs.forEach((t) => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              // console.log(searchValue)
              if (t.src.includes(searchValue)) {
                t.parentElement.parentElement.parentElement.style.display =
                  "block";
              } else {
                t.parentElement.parentElement.parentElement.style.display =
                  "none";
              }
            });
          }
        }
      });
    } else {
      if (thumbs.length > 0) {
        thumbs.forEach((t) => {
          if (color_dropdown[0] != null) {
            let searchValue = color_dropdown[0].value
              .split(" ")[0]
              .toLowerCase();
            if (t.src.includes(searchValue)) {
              t.parentElement.parentElement.style.display = "block";
            } else {
              t.parentElement.parentElement.style.display = "none";
            }
          }
        });
      }

      if (stackedThumbs.length > 0) {
        stackedThumbs.forEach((t) => {
          if (color_dropdown[0] != null) {
            let searchValue = color_dropdown[0].value
              .split(" ")[0]
              .toLowerCase();
            if (t.src.includes(searchValue)) {
              t.parentElement.parentElement.style.display = "block";
            } else {
              t.parentElement.parentElement.style.display = "none";
            }
          }
        });
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateMaxVariantQuantity() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantID = urlParams.get("variant");
    const variantData = this.additionalVariantData[variantID];
    const quantityInput = document.querySelector(
      '.product input[name="quantity"]',
    );

    if (Number(quantityInput.value) == 0) {
      quantityInput.value = 1;
    }

    //Check first if negative number
    if (Number(variantData.inventory) > 0) {
      if (Number(quantityInput.value) > Number(variantData.inventory)) {
        quantityInput.value = variantData.inventory;
        quantityInput.setAttribute("max", variantData.inventory);
      }
    }
    //If current inventory returns as negative, set the quantity value to 1
    //If its out of stock, the button will be disabled anyway
    //If it's negative but set to Not Track, setting to 1 will ensure they can still buy
    else if (Number(variantData.inventory) < 0) {
      quantityInput.value = 1;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    let price = document.querySelector(".price-item").innerText;
    let hidePrice =
      document.querySelector("[data-hide-price]").dataset.hidePrice;

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");

      if (hidePrice != "true") {
        addButtonText.textContent =
          window.variantStrings.addToCart + " - " + price;
      }
    }

    if (!modifyClass) return;
  }

  setPriceLabelAddButton() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const button = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    let price = document.querySelector(".price-item").innerText;
    let hidePrice =
      document.querySelector("[data-hide-price]").dataset.hidePrice;

    if (button.hasAttribute("disabled")) {
      addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      if (hidePrice != "true") {
        addButtonText.textContent =
          window.variantStrings.addToCart + " - " + price;
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setColorVariantLabel() {
    let colorLabel = document.querySelector(".color_label");
    let colorInputs = document.querySelectorAll("input[name=Color]");

    for (var i = 0; i < colorInputs.length; i++) {
      if (colorInputs[i].checked) {
        colorLabel.innerHTML +=
          "<span class='color__variant'>: " + colorInputs[i].value + "</span>";
      }
    }
  }

  removeColorVariantLabel() {
    let colorVariant = document.querySelector(".color__variant");
    if (colorVariant !== "undefined" && colorVariant !== null) {
      colorVariant.remove();
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// TODO Move this to quantityInput
/** Setting Quantity input to maximum product quantity on keyboard input **/
const quantityInput = document.querySelector('.product input[name="quantity"]');
if (quantityInput) {
  quantityInput.addEventListener("change", function () {
    let qtyMax = quantityInput.getAttribute("max");
    if (qtyMax != null && Number(quantityInput.value) > qtyMax) {
      quantityInput.value = qtyMax != 0 ? qtyMax : 1;
    }
  });
}

function readjustMenuHeight(menu) {
  // Re-adjust menu height based on sub-menu content height
  if (!menu) return;

  const subMenuCategories = menu.querySelector(
    ".header__submenu-has-children.is-open .header__submenu__row-flex",
  );

  menu.style.minHeight = "auto";
  if (
    subMenuCategories &&
    subMenuCategories.offsetHeight + 90 > menu.offsetHeight
  ) {
    // It has sub categories and it's height is greater than menu height
    menu.style.minHeight = subMenuCategories.offsetHeight + 90 + "px";
    subMenuCategories.parentElement.style.height =
      menu.offsetHeight - 50 + "px"; // Readjust sub categories border-left height
  } else if (subMenuCategories) {
    // It has sub categories and it's height is smaller than menu height
    menu.style.minHeight = menu.offsetHeight + 50 + "px";
    subMenuCategories.parentElement.style.height =
      menu.offsetHeight - 50 + "px"; // Readjust sub categories border-left height
  } else {
    // If it hasn't sub categories we need less additional height
    menu.style.minHeight = menu.offsetHeight + 30 + "px";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const menuDisclosures = document.querySelectorAll(
    "details-disclosure > details",
  );

  if (!menuDisclosures.length) return;

  menuDisclosures.forEach((disclosure) => {
    disclosure.addEventListener("toggle", () => {
      const menu = disclosure.querySelector(".header__submenu-contents");
      readjustMenuHeight(menu);
    });
  });
});

let hoverTimeout;

function onNavLink(e) {
  hoverTimeout = setTimeout(() => {
    this.parentElement.parentElement
      .querySelectorAll(".header__submenu-has-children, .child__link-all>a")
      .forEach((headerSubmenu) => {
        headerSubmenu.classList.remove("is-open");
      });
    this.classList.add("is-open");

    const menu = this.parentElement.parentElement.parentElement.parentElement;

    readjustMenuHeight(menu);
  }, 150);
}

document.addEventListener("DOMContentLoaded", function () {
  var windowWidth = window.innerWidth;
  if (windowWidth > 990) {
    const desktopNavLinks = document.querySelectorAll(
      ".header__submenu--left-rail.header__link-lists .header__submenu-has-children, .child__link-all>a",
    );
    desktopNavLinks.forEach((desktopNavLink) => {
      desktopNavLink.addEventListener("mouseover", onNavLink);
      desktopNavLink.addEventListener("mouseout", () =>
        clearTimeout(hoverTimeout),
      );
    });
  }
});

(function searchspringCarouselTabSwitching() {
  let sectionSelectorSSRecs = ".searchspring-reviews";

  if (
    document.querySelectorAll(
      `${sectionSelectorSSRecs} .recommendations__collection-selector`,
    )
  ) {
    let collectionSelectorsSSRecs = document.querySelectorAll(
      `${sectionSelectorSSRecs} .recommendations__collection-selector`,
    );

    for (let collectionSelector of collectionSelectorsSSRecs) {
      let blockId = collectionSelector.dataset.blockId;
      let currentParent = collectionSelector.parentNode.parentNode.parentNode;

      let collectionCarousel = currentParent.querySelector(
        `.recommendations__collection[data-block-id="${blockId}"]`,
      );
      let otherCarousels = currentParent.querySelectorAll(
        `.recommendations__collection:not([data-block-id="${blockId}"])`,
      );

      collectionSelector.addEventListener("click", () => {
        for (let otherCarousel of otherCarousels) {
          otherCarousel.classList.remove("active");
        }

        for (let collectionSelector of collectionSelectorsSSRecs) {
          collectionSelector.classList.remove("active");
        }

        collectionSelector.classList.add("active");
        collectionCarousel.classList.add("active");

        window.dispatchEvent(new Event("resize"));
      });
    }
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  // Get all "PDP" buttons on the collection page
  const pdpButtons = document.querySelectorAll(".pdpButton");

  pdpButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const productHandle = button.getAttribute("data-product-handle");
      const pdpButton_Link = button
        .closest(".product-item")
        .querySelector(".pdpButton_URL").textContent;

      setTimeout(function () {
        window.location.href = pdpButton_Link;
      }, 1000);
    });
  });

  if (document.querySelector(".klaviyo-bis-trigger")) {
    // Simulate click on the "GET IN-STOCK ALERT" button after page load
    setTimeout(function () {
      const klaviyoButton = document.querySelector(".klaviyo-bis-trigger");
      if (klaviyoButton) {
        console.log("Triggering click on the Klaviyo button...");
        klaviyoButton.click();
      }
    }, 1000);
  }
});

// video badge for collection page

function waitForElement(selector) {
  return new Promise((resolve) => {
    const element = document.querySelectorAll(selector);
    console.log("length", element.length);
    if (element.length > 0) {
      return resolve(element);
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelectorAll(selector);
      if (element.length > 0) {
        resolve(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// Promise.all([
//   waitForElement('.ss__result__details'),
//   waitForElement('.plp-card-text')
// ]).then(([detailsList, cardTexts]) => {

//   detailsList.forEach(details => {
//     cardTexts.forEach(card => {
//       details.appendChild(card.cloneNode(true));
//     });
//   });

// });

function cloneCards() {
  const detailsList = document.querySelectorAll(".ss__result__details");
  const cardTexts = document.querySelectorAll(".plp-card-text");

  detailsList.forEach((details, i) => {
    if (!details.dataset.cardsCloned) {
      // avoid duplicating
      if (cardTexts[i]) {
        details.appendChild(cardTexts[i].cloneNode(true));
        details.dataset.cardsCloned = "true";
        cardTexts.style.display = "block";
      }
    }
  });
}

// Observe DOM for new products
const observer = new MutationObserver(cloneCards);

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Run once initially in case elements already exist
cloneCards();

window.addEventListener("load", async () => {
  const parent = await waitForElement(".ss__result__details");

  parent.forEach((parent) => {
    if (!parent) return;

    const newDiv = document.createElement("div");
    newDiv.classList.add("videoContent");
    if (parent.children.length > 1) {
      parent.children[0].after(newDiv);

      console.log("added div successfully");
    } else {
      parent.appendChild(newDiv);
    }
  });

  console.log("added successfully");
});

async function processProducts() {
  const parents = await waitForElement(".ss__result__details");
  const videoBadge = document.getElementsByClassName("collection-videoWrapper");

  console.log("video badeg", videoBadge);

  parents.forEach((parent) => {
    if (parent.querySelector(".videoContent")) return;

    const newDiv = document.createElement("div");
    newDiv.classList.add("videoContent");

    if (parent.children.length > 1) {
      parent.children[0].after(newDiv);
    } else {
      parent.appendChild(newDiv);
    }
  });

  const links = document.querySelectorAll(".ss__result-link");

  links.forEach((link) => {
    if (link.dataset.videoChecked) return;
    link.dataset.videoChecked = "true";

    const url = link.getAttribute("href");
    const handle = url.split("/products/")[1]?.split("?")[0];

    const productCard = link.closest(".ss__result");
    const videoContainer = productCard?.querySelector(".videoContent");

    if (!handle || !videoContainer) return;

    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        const hasVideo = product.media.some(
          (media) =>
            media.media_type === "video" ||
            media.media_type === "external_video",
        );
        if (hasVideo) {
          videoContainer.innerHTML = videoBadge[0].innerHTML;
        }
      });
  });
}
window.addEventListener("load", function () {
  processProducts();
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".ss__load-more__btn")) {
    console.log("load clicked");

    setTimeout(() => {
      processProducts();
    }, 1000);
  }
});

// PDP Video badge
document.querySelectorAll(".video-badge").forEach((badge) => {
  badge.addEventListener("click", function (e) {
    e.preventDefault();

    const slide = badge.closest(".product__media-item");
    const slider = slide.closest(".product__media-list");
    if (!slider) return;

    const videoSlide = slider.querySelector(
      '.product__media-item[data-media-type="video"], .product__media-item[data-media-type="external_video"]',
    );
    if (!videoSlide) return;

    // Remove active state
    slider.querySelectorAll(".product__media-item").forEach((item) => {
      item.classList.remove("is-active");
    });

    // Add active class
    videoSlide.classList.add("is-active");

    // Scroll to video slide (important for mobile)
    slider.scrollTo({
      left: videoSlide.offsetLeft,
      behavior: "smooth",
    });

    // Play video if exists
    const video = videoSlide.querySelector("video");
    if (video) {
      video.play();
    }
  });
});

// waitForElement('.ss__result__details').then(() => {
//   const detailsList = document.querySelectorAll('.ss__result__details');
//   const cardTexts = document.querySelectorAll('.plp-card-text');

//   console.log("details found:", detailsList.length);
//   console.log("cardTexts found:", cardTexts.length);

//   detailsList.forEach((details, index) => {
//     const cardText = cardTexts[index];
//     if (cardText && !details.contains(cardText)) {
//       details.appendChild(cardText);
//       console.log("appended cardText", index);
//     }
//   });
// });

// const observer = new MutationObserver(() => {
//   const detailsList = document.querySelectorAll('.ss__result__details');
//   const cardTexts = document.querySelectorAll('.plp-card-text');

//   if (detailsList.length && cardTexts.length) {
//     detailsList.forEach(details => {
//       cardTexts.forEach(card => {
//         details.appendChild(card.cloneNode(true));
//       });
//     });

//     observer.disconnect(); // stop once done
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

function Badgepill() {
  const detailparent = document.querySelectorAll(".product-card-top-wrapper");

  detailparent.forEach((details) => {
    if (details.dataset.badgeApplied === "true") return;

    const badge = details.querySelector(".ss__badge-pill");
    const detailsDiv = details.querySelector(".ss__result__details");

    if (badge && detailsDiv) {
      detailsDiv.appendChild(badge.cloneNode(true));

      details.dataset.badgeApplied = "true";
    }
  });

  console.log("Badges appended", detailparent);
}

const observer1 = new MutationObserver(() => {
  Badgepill();
});

observer1.observe(document.body, {
  childList: true,
  subtree: true,
});

// badge PDP
document.addEventListener("DOMContentLoaded", function () {
  const openBtns = document.querySelectorAll(".demo-open-drawer");
  const drawer = document.getElementById("demoDrawer");
  const blackOverlay = document.querySelector(".black-overlay");
  const closeBtn = document.querySelector(".drawer-close");

  function closeDrawer() {
    drawer.classList.remove("open");
    blackOverlay.classList.remove("open");
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation(); // 🔥 prevent instant close
      drawer.classList.add("open");
      blackOverlay.classList.add("open");
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      closeDrawer();
    });
  }

  document.addEventListener("click", function () {
    closeDrawer();
  });

  drawer.addEventListener("click", function (e) {
    e.stopPropagation();
  });
});
